export default {
  geolocation: {
    lat: '47.4979',
    lng: '19.0402',
    label: '1011 Budapest',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
